import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import './main.less';

import SelectField from '../../../shared/form-elements/select/field';
import Checkbox from '../../../shared/form-elements/checkbox';

const Form = props => {

	return (
		<form className="display-flex">
			<div className="ui-form__element width-300">
				<Field
					name="is_showed_duplicates"
					placeholder={'Show duplicates'}
					component={Checkbox}
				/>
			</div>
			<div className="ui-form__element width-300">
				<Field
					name='cancellation_reason'
					placeholder={'Cancellation reason'}
					component={SelectField}
					multi={false}
					showLabel={false}
					clearable={false}
					searchable={false}
					options={props.cancellation_reasons.map(i => ({ value: i.id, label: i.id}))}
				/>
			</div>
		</form>
	);
};

Form.propTypes = {
	intl: PropTypes.func
};

export default connect(state => ({
	cancellation_reasons: state.root.lists['conversion-cancellation-reasons']
}))(reduxForm({ form: 'selectCancellationReasonForm', enableReinitialize: true })(Form));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/select-cancellation-reason-form/main.js